/**
 * Styles for the Advanced settings section.
 *
 * Section/group layout lives in SettingGroup.module.css — only the controls
 * unique to this section are here.
 */

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 0;
}

.hint {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
  padding-top: 8px;
  border-top: 1px solid #2d2d2d;
}
